import { useLocation } from "react-router-dom";
import { useDetalleMutuo } from "../../../context/mutuoContext";
import { useState, useEffect, Suspense } from "react";
import * as yup from 'yup'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormularioLiquidacionDto } from "../interfaces/formularioLiquidacionDto";
import { StateViewInterface } from "../interfaces/stateViews.interface";
import { Card, CardContent, Grid2 } from "@mui/material";
import {AttachMoney, Calculate, ArrowBack} from "@mui/icons-material"

import Breadcrumb from "../../../components/ui/materialui/breadcrumb";

import InputFecha from '../../../components/inputs/yup/materialui/inputFecha';
import InputSelect from '../../../components/inputs/yup/materialui/inputSelect';
import InputText from '../../../components/inputs/yup/materialui/inputText';
import InputTextArea from '../../../components/inputs/yup/materialui/inputTextArea';
import InputNumber from '../../../components/inputs/yup/materialui/inputNumber';
import CustomAccordion from "../../../components/ui/materialui/customAccordion";
import MButton from "../../../components/inputs/yup/materialui/mButton";
import { obtenerResumen, recalcularLiquidacion, subirLiquidacionPrepago, generarRemesaPrepago, recalcularRemesaPrepago } from "../services/servicePrepago";
import Conversiones from "../../../utils/conversiones";
import { GenerarLiquidacionPrepagoDto } from "../interfaces/generarLiquidacionPrepagoDto";
import { useToast } from "../../../hooks/useToast";
import ConfirmationModal from "../../../components/ui/materialui/confirmationModal";
import { RecalcularLiquidacionPrepago } from "../interfaces/recalcularLiquidacionprepago";
import InputRut from "../../../components/inputs/yup/materialui/inputRut";
import { ResponseResumenSolicitudDto } from "../interfaces/responseResumenSolicitud";
import { RecalculoRemesaPrepagoRequest } from "../interfaces/recalculoRemesaPrepagoRequest";
import { ResponseCalculoLiquidacion } from "../interfaces/responseCalculoLiquidacion";
import { ResponseRecalculoRemesaPrepago } from "../interfaces/responseRecalculoRemesaPrepago";
import { PermissionGuard } from "../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../utils/enums";

interface IProps {
    idSolicitud: number,
    setViewToShow: (nameView: keyof StateViewInterface) => void;
    setIdSolicitud: (idSolicitud: number) => void;
    isLiquidar: boolean;
}

const LiquidarRemesarSolicitud: React.FC<IProps> = ({ idSolicitud, setViewToShow, setIdSolicitud, isLiquidar }: IProps) => {

    const location = useLocation();
    const { id: idEmergente } = location.state || {}
    const { nombre, filtros, tipoMutuo, numeroOperacion } = useDetalleMutuo();
    const [ idMutuo, setIdMutuo ] = useState<number>(idEmergente);
    const { addToast } = useToast();
    const [ isValidToGenerate, setIsValidToGenerate ] = useState<boolean>(true);

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    })

    const showToast = (title: string, tipo: "Success" | "Danger" | "Warning" | "Info" | "Dark" | "Light", mensaje: string) => {
        addToast({
          mostrar: true,
          titulo: title,
          tipo,
          mensaje,
        });
    }

    const validationSchema: yup.ObjectSchema<FormularioLiquidacionDto> = yup.object().shape({
        numeroOperacion: yup.string().required("Campo requerido"),
        rutDeudor: yup.string().required("Campo requerido"),
        nombreDeudor: yup.string().required("Campo requerido"),
        tipoCredito: yup.string().required("Campo requerido"),
        factorComisionPrepago: yup.number().required("Campo requerido").min(0),
        motivoPrepago: yup.string().required("Campo requerido"),
        tipoPrepago: yup.string().required("Campo requerido"),
        modoPagoPrepago: yup.string(),
        modoPago: yup.string().required("Campo requerido"),
        montoPrepago: yup.number().required("Campo requerido").min(0),
        dividendosImpagos: yup.number().required("Campo requerido").min(0),
        monedaOrigen: yup.string().required("Campo requerido"),
        montoPrepagoCapital: yup.number().required("Campo requerido").min(0),
        interesDevengado: yup.number().required("Campo requerido").min(0),
        segurosMesPrepago: yup.number().required("Campo requerido").min(0),
        provisionDividendos: yup.number().required("Campo requerido").min(0),
        interesPenalDividendos: yup.number().required("Campo requerido").min(0),
        gastosCobranzaDividendo: yup.number().required("Campo requerido").min(0),
        gastosAlzamiento: yup.number().required("Campo requerido").min(0),
        tipoCambioMonedaOrigen: yup.number().required("Campo requerido").min(0),
        nuevoSaldoActual: yup.number().required("Campo requerido").min(0),
        comisionPrepago: yup.number().required("Campo requerido").min(0),
        montoDividendosImpagos: yup.number().required("Campo requerido").min(0),
        totalAPagar: yup.number().required("Campo requerido").min(0),
        fechaPago: yup.date().required("Campo requerido"),
        notaRecomendaciones: yup.string().required("Campo requerido"),
        notaValidezPrepago: yup.string().required("Campo requerido"),
        notaFormaPago: yup.string().required("Campo requerido"),
        //Se agregan campos faltantes
        saldoInsoluto: yup.number().required("Campo requerido").min(0),
        interesDividendos: yup.number().required("Campo requerido").min(0),
        desgravamenSeguro: yup.number().required("Campo requerido").min(0),
        incendioSeguros: yup.number().required("Campo requerido").min(0),
        cesantiaSeguro: yup.number().required("Campo requerido").min(0),
        otrosSeguros: yup.number().required("Campo requerido").min(0)        
    });

    const {
        register,
        formState: { errors, isDirty },
        handleSubmit,
        reset,
        setValue,
        clearErrors,
        control,
        watch,
        trigger
    } = useForm<FormularioLiquidacionDto>({ resolver: yupResolver(validationSchema), mode: "onChange" })

    const watcher = watch();

    const cargarFormulario = async () => {
        const response = await obtenerResumen(idMutuo, idSolicitud);
        if (response.status === 200){
            const responseData = response.data;
            const formInicial : FormularioLiquidacionDto = {
                numeroOperacion: responseData.numeroOperacion,
                rutDeudor: responseData.rutDeudor,
                nombreDeudor: responseData.nombresDeudor,
                tipoCredito: responseData.tipoProducto,
                factorComisionPrepago: responseData.factorComisionPrepago,
                motivoPrepago: responseData.motivoPrepago,
                tipoPrepago: responseData.tipoPrepago,
                modoPagoPrepago: responseData.modoPagoPrepago,
                modoPago: "EFECTIVO",
                montoPrepago: responseData.montoPrepago,
                dividendosImpagos: responseData.dividendosImpagos,
                monedaOrigen: responseData.monedaOrigen,
                montoPrepagoCapital: responseData.montoPrepagoCapital,
                interesDevengado: responseData.interesDevengado,
                segurosMesPrepago: responseData.seguroMes,
                provisionDividendos: responseData.provisionDividendos - responseData.provisionDividendos, // Se setea en 0, no se cobra provisión en la liquidación
                interesPenalDividendos: responseData.interesPenalDividendos,
                gastosCobranzaDividendo: responseData.gastosCobranzaDividendos,
                gastosAlzamiento: responseData.gastosAlzamiento,
                tipoCambioMonedaOrigen: responseData.tipoCambio,
                nuevoSaldoActual: responseData.nuevoSaldoActual,
                comisionPrepago: responseData.comision,
                montoDividendosImpagos: responseData.montoDividendosImpagos,
                totalAPagar: responseData.totalPagar - responseData.provisionDividendos, // Se descuenta la provisión que no se cobra               
                fechaPago: FechaPago(responseData),
                notaRecomendaciones: `Liquidación válida hasta ${Conversiones.fechaCorta(FechaPago(responseData))} por concepto de carta de resguardo.`,
                notaValidezPrepago: `Las obligaciones del deudor del presente mutuo sólo se extinguirán una vez que éste pague la deuda, así como los demás gastos asociados que pudiesen devengarse a favor del acreedor. Por tanto, en caso de refinanciamiento el deudor deberá continuar pagando sus dividendos.`,
                notaFormaPago: `El pago efectuado con cheque u otro documento tiene el caracter de condicional mientras los montos no sean percibidos por Metlife Chile Administradora de Mutuos Hipotecarios S.A.`,

                saldoInsoluto: responseData.saldoInsoluto,
                interesDividendos: responseData.interesDividendos,
                desgravamenSeguro: responseData.desgravamenSeguro,
                incendioSeguros: responseData.incendioSeguros,
                cesantiaSeguro: responseData.cesantiaSeguro,
                otrosSeguros: responseData.otrosSeguros
            }
            reset(formInicial);
        }   


        function FechaPago(responseData: ResponseResumenSolicitudDto): Date {
            return responseData.fechaPago ? new Date(responseData.fechaPago) : new Date();
        }
    }

    useEffect(() => {
        cargarFormulario()
    }, [idSolicitud, idMutuo])

    const generarRemesa = async( e: FormularioLiquidacionDto ) => {
        // Construiccion de DTO
        const solicitud : GenerarLiquidacionPrepagoDto = {
            mutuoId: idMutuo,
            solicitudId: idSolicitud,
            fechaPago: e.fechaPago,
            modoPago: e.modoPago,
            notaRecomendaciones: e.notaRecomendaciones,
            notaFormaPrepago: e.notaFormaPago,
            notaValidacionPrepago: e.notaValidezPrepago,
            ignorarDivImpagos: true,
            factorComisionPrepago: e.factorComisionPrepago,
            motivoPrepago: e.motivoPrepago,
            tipoPrepago: e.tipoPrepago,
            montoPrepagoCapital: e.montoPrepagoCapital,
            comisionPrepago: e.comisionPrepago,
            interesDevengado: e.interesDevengado,
            segurosMesPrepago: e.segurosMesPrepago,
            provisionDividendos: e.provisionDividendos,
            montoDividendosImpagos: e.montoDividendosImpagos,
            interesPenalDividendos: e.interesPenalDividendos,
            gastosCobranzaDividendos: e.gastosCobranzaDividendo,
            gastosAlzamiento: e.gastosAlzamiento,
            totalPagar: e.totalAPagar,
            nuevoSaldoActual: e.nuevoSaldoActual,
            valorCambioMutuo: e.tipoCambioMonedaOrigen,
            monedaOrigen: e.monedaOrigen,

            saldoInsoluto: e.saldoInsoluto,
            interesDividendos: e.interesDividendos,
            desgravamenSeguro: e.desgravamenSeguro,
            incendioSeguros: e.incendioSeguros,
            cesantiaSeguro: e.cesantiaSeguro,
            otrosSeguros: e.otrosSeguros
        };

        // Hacemos la peticion para remesar prepago (retorna un archivo)
        const response = await generarRemesaPrepago(solicitud);
        const isResponseOk = response.status === 200 || response.status === 201;

        if( !isResponseOk ) {
            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: response.response.data.message,
            });
            return;
        }

        // Descargamos el achivo
        // 1. Decodificar base64 → bytes
        const byteCharacters = atob(response.data.fileContent);
        const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);

        // 2. Crear Blob seguro
        const blob = new Blob([byteArray], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        // 3. Crear URL temporal
        const url = URL.createObjectURL(blob);

        // 4. Crear link de descarga
        const link = document.createElement("a");
        link.href = url;

        // Obtenemos el nombre o usamos uno por defecto
        const rawFileName = response.data.fileName || "archivo.xlsx";

        // Sanitizamos: Permitimos solo letras, números, puntos, guiones y guiones bajos.
        // Cualquier otro caracter se reemplaza por un guion bajo.
        // Esto satisface a Veracode porque ve una función de limpieza.
        const cleanFileName = rawFileName.replace(/[^a-zA-Z0-9._-]/g, "_");

        link.download = cleanFileName;
        // -----------------------

        document.body.appendChild(link);
        link.click();

        // 5. Limpieza
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        addToast({
            mostrar: true,
            titulo: 'Éxito',
            tipo: 'Success',
            mensaje: "Remesa de prepago generada",
        });
        cancelarLiquidacion();
    };

    const generarLiquidacion = async( e: FormularioLiquidacionDto, ignorarDiv: boolean) => {
        //1) Armar objeto
        const solicitud : GenerarLiquidacionPrepagoDto = {
            mutuoId: idMutuo,
            solicitudId: idSolicitud,
            fechaPago: e.fechaPago,
            modoPago: e.modoPago,
            notaRecomendaciones: e.notaRecomendaciones,
            notaFormaPrepago: e.notaFormaPago,
            notaValidacionPrepago: e.notaValidezPrepago,
            ignorarDivImpagos: ignorarDiv,
            factorComisionPrepago: e.factorComisionPrepago,
            motivoPrepago: e.motivoPrepago,
            tipoPrepago: e.tipoPrepago,
            montoPrepagoCapital: e.montoPrepagoCapital,
            comisionPrepago: e.comisionPrepago,
            interesDevengado: e.interesDevengado,
            segurosMesPrepago: e.segurosMesPrepago,
            provisionDividendos: e.provisionDividendos,
            montoDividendosImpagos: e.montoDividendosImpagos,
            interesPenalDividendos: e.interesPenalDividendos,
            gastosCobranzaDividendos: e.gastosCobranzaDividendo,
            gastosAlzamiento: e.gastosAlzamiento,
            totalPagar: e.totalAPagar,
            nuevoSaldoActual: e.nuevoSaldoActual,
            valorCambioMutuo: e.tipoCambioMonedaOrigen,
            monedaOrigen: e.monedaOrigen,

            saldoInsoluto: e.saldoInsoluto,
            interesDividendos: e.interesDividendos,
            desgravamenSeguro: e.desgravamenSeguro,
            incendioSeguros: e.incendioSeguros,
            cesantiaSeguro: e.cesantiaSeguro,
            otrosSeguros: e.otrosSeguros
        }

        //2) Enviar objeto
        const response = await subirLiquidacionPrepago(solicitud);
        const isResponseOk = response.status === 200 || response.status === 201;
        const validoParaConfirmar = !isResponseOk && !ignorarDiv && response.response.data.message.toString().includes("Advertencia")

        //3) Procesar respuesta
        if (validoParaConfirmar){
            setModalConfirmacion({
                show: true,
                title: 'Confirmación',
                message: response.response.data.message + " ¿Está seguro que quiere continuar?",
                metodo: () => {generarLiquidacion(e, true)}
            });
            return;
        }
        else if (!isResponseOk){
            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: response.response.data.message,
            });
            return;
        }

        //4) Descargar Archivo
        
        // 1. Decodificar base64 → bytes
        const byteCharacters = atob(response.data.fileContent);
        const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);

        // 2. Crear Blob seguro
        const blob = new Blob([byteArray], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        // 3. Crear URL temporal
        const url = URL.createObjectURL(blob);

        // 4. Crear link de descarga
        const link = document.createElement("a");
        link.href = url;

        // Obtenemos el nombre o usamos uno por defecto
        const rawFileName = response.data.fileName || "archivo.xlsx";

        // Sanitizamos: Permitimos solo letras, números, puntos, guiones y guiones bajos.
        // Cualquier otro caracter se reemplaza por un guion bajo.
        // Esto satisface a Veracode porque ve una función de limpieza.
        const cleanFileName = rawFileName.replace(/[^a-zA-Z0-9._-]/g, "_");

        link.download = cleanFileName;
        // -----------------------

        document.body.appendChild(link);
        link.click();

        // 5. Limpieza
        document.body.removeChild(link);
        URL.revokeObjectURL(url);


        addToast({
            mostrar: true,
            titulo: 'Éxito',
            tipo: 'Success',
            mensaje: "Liquidación de prepago generada",
        });
        cancelarLiquidacion();
    }

    const submitFormulario = async (e: FormularioLiquidacionDto) => {
        isLiquidar ? generarLiquidacion(e, false) : generarRemesa(e);
    }

       

    const handleRecalcularRemesaPrepago = async () => {

        const recalculoRemesaPrepagoRequest: RecalculoRemesaPrepagoRequest = {
            mutuoId: idMutuo,
            solicitudId: idSolicitud,
            fechaRemesa: watcher.fechaPago
        }

        const response = await recalcularRemesaPrepago(recalculoRemesaPrepagoRequest)

        if (response.status === 200 || response.status ===201){
            const recalculoRemesaPrepago: ResponseRecalculoRemesaPrepago = response.data

            resetValues();

            setValue("montoPrepagoCapital", recalculoRemesaPrepago.montoPrepagoCapital)
            setValue("interesDevengado", recalculoRemesaPrepago.interesDevengado)
            setValue("comisionPrepago", recalculoRemesaPrepago.comisionPrepago)
            setValue("gastosCobranzaDividendo", recalculoRemesaPrepago.gastosCobranzaDividendo)
            setValue("gastosAlzamiento", recalculoRemesaPrepago.gastosAlzamiento)
            setValue("segurosMesPrepago", recalculoRemesaPrepago.segurosMesPrepago)
            setValue("montoDividendosImpagos", recalculoRemesaPrepago.montoDividendosImpagos)
            setValue("interesPenalDividendos", recalculoRemesaPrepago.interesPenalDividendos)
            setValue("provisionDividendos", recalculoRemesaPrepago.provisionDividendos) // Viene en 0 desde el backend, no se cobra provisión en la remesa
            setValue("totalAPagar", recalculoRemesaPrepago.totalAPagar) // Viene descontada la provisión que no se cobra
            setValue("nuevoSaldoActual", recalculoRemesaPrepago.nuevoSaldoActual)
            setValue("tipoCambioMonedaOrigen", recalculoRemesaPrepago.tipoCambioMonedaOrigen)

            //Se agregan campos faltantes
            setValue("saldoInsoluto", recalculoRemesaPrepago.saldoInsoluto)
            setValue("interesDividendos", recalculoRemesaPrepago.interesDividendos)
            setValue("desgravamenSeguro", recalculoRemesaPrepago.desgravamenSeguro)
            setValue("incendioSeguros", recalculoRemesaPrepago.incendioSeguros)
            setValue("cesantiaSeguro", recalculoRemesaPrepago.cesantiaSeguro)
            setValue("otrosSeguros", recalculoRemesaPrepago.otrosSeguros)

            setIsValidToGenerate(true);

            if (recalculoRemesaPrepago?.errores.length > 0){
                setIsValidToGenerate(false);
                showToast("Remesar solicitud de prepago", "Danger", recalculoRemesaPrepago.errores[0])
            }
        }
        else {
            setIsValidToGenerate(false);
        }
    }

    const resetValues = () => {
        setValue("montoPrepagoCapital", 0)
        setValue("interesDevengado", 0)
        setValue("comisionPrepago", 0)
        setValue("gastosCobranzaDividendo", 0)
        setValue("gastosAlzamiento", 0)
        setValue("segurosMesPrepago", 0)
        setValue("montoDividendosImpagos", 0)
        setValue("interesPenalDividendos", 0)
        setValue("provisionDividendos", 0) 
        setValue("totalAPagar", 0)
        setValue("nuevoSaldoActual", 0)
        setValue("tipoCambioMonedaOrigen", 0)

        //Se agregan campos faltantes
        setValue("saldoInsoluto", 0)
        setValue("interesDividendos", 0)
        setValue("desgravamenSeguro", 0)
        setValue("incendioSeguros", 0)
        setValue("cesantiaSeguro", 0)
        setValue("otrosSeguros", 0)

        setIsValidToGenerate(false);
    }

    const handleRecalcularLiquidacion = async () => {
        const input : RecalcularLiquidacionPrepago = {
            tipoPago: watcher.tipoPrepago,
            modoPago: watcher.modoPagoPrepago,
            montoPago: watcher.tipoPrepago === 'Parcial' ? watcher.montoPrepago : 0,
            motivoPrepago: watcher.motivoPrepago,
            tieneGastosAlzamiento: watcher.gastosAlzamiento > 0,
            fechaPago: watcher.fechaPago,
            mutuoId: idMutuo
        };

        var response = await recalcularLiquidacion(input);
        
        if (response.status === 200 || response.status === 201){
            const calculoData = response.data;
            setValue("montoPrepagoCapital", calculoData.montoPrepagoCapital)
            setValue("interesDevengado", calculoData.interesDevengado)
            setValue("comisionPrepago", calculoData.comisionPrepago)
            setValue("gastosCobranzaDividendo", calculoData.gastosCobranzas)
            setValue("gastosAlzamiento", calculoData.gastosAlzamiento)
            setValue("segurosMesPrepago", calculoData.seguros)
            setValue("montoDividendosImpagos", calculoData.montoDivImpago)
            setValue("interesPenalDividendos", calculoData.interesPenal)
            setValue("provisionDividendos", calculoData.provisionDividendos - calculoData.provisionDividendos) // Se setea en 0, no se cobra provisión en la liquidación
            setValue("totalAPagar", calculoData.total - calculoData.provisionDividendos) // Se descuenta la provisión que no se cobra
            setValue("nuevoSaldoActual", calculoData.saldo)
            setValue("tipoCambioMonedaOrigen", calculoData.valorCambioMutuo)

            //Se agregan campos faltantes
            setValue("saldoInsoluto", calculoData.saldoInsoluto)
            setValue("interesDividendos", calculoData.interesesDividendos)
            setValue("desgravamenSeguro", calculoData.desgravamenSeguros)
            setValue("incendioSeguros", calculoData.incendioSeguros)
            setValue("cesantiaSeguro", calculoData.seguroCesantia)
            setValue("otrosSeguros", calculoData.otrosSeguros)            
        }
    }

    const cancelarLiquidacion = () => {
        setIdSolicitud(0);
        setViewToShow("showListadoSolicitudes")
    }

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Cartera mutuos', state: filtros, url: '/cartera-mutuos' },
        { label: 'Prepagos', active: true },
        { label: `${numeroOperacion ?? ''} - ${tipoMutuo ?? ""} - ${nombre ?? ''}`, active: true },
    ];

    const monedaOrigenWatcher = watch("monedaOrigen")

    return(
        <>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({ ...modalConfirmacion, show: false })
                }
                onConfirm={modalConfirmacion.metodo}
                title={modalConfirmacion.title}
                show={modalConfirmacion.show}
                message={modalConfirmacion.message}
            />
            <Grid2 size={{ xs: 12, lg: 8 }}> <Breadcrumb items={breadcrumbItems} /> </Grid2>
            <Card sx={{ mb: 2, backgroundcolor: 'white' }} raised>
                <CardContent>
                    <Suspense>
                        <form onSubmit={handleSubmit(submitFormulario)}>
                            <CustomAccordion
                                title={isLiquidar ? 'Liquidación de Prepago' : 'Remesa de Prepago'}
                                expandedDefault
                            >
                                <>
                                    <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputText
                                                name={"numeroOperacion"}
                                                control={control}
                                                desabilitado
                                                readonly
                                                label="Número operación"
                                                error={errors.numeroOperacion}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputRut
                                                name={"rutDeudor"}
                                                control={control}
                                                readonly
                                                label="Rut deudor"
                                                error={errors.rutDeudor}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputText
                                                name={"nombreDeudor"}
                                                control={control}
                                                desabilitado
                                                readonly
                                                label="Nombre deudor"
                                                error={errors.nombreDeudor}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputText
                                                name={"tipoCredito"}
                                                control={control}
                                                desabilitado
                                                readonly
                                                label="Tipo crédito"
                                                error={errors.tipoCredito}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"factorComisionPrepago"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={1}
                                                label="Factor comisión prepago"
                                                error={errors.factorComisionPrepago}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputText
                                                name={"motivoPrepago"}
                                                control={control}
                                                desabilitado
                                                readonly
                                                label="Motivo prepago"
                                                error={errors.motivoPrepago}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputText
                                                name={"tipoPrepago"}
                                                control={control}
                                                desabilitado
                                                readonly
                                                label="Tipo prepago"
                                                error={errors.tipoPrepago}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputText
                                                name={"modoPagoPrepago"}
                                                control={control}
                                                desabilitado
                                                readonly
                                                label="Modo pago prepago"
                                                error={errors.modoPagoPrepago}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputSelect
                                                name="modoPago"
                                                label="Modo pago"
                                                control={control}
                                                options={[
                                                    { value: "CHEQUE", label: "Cheque" },
                                                    { value: "EFECTIVO", label: "Efectivo" }
                                                ]}
                                                error={errors.modoPago}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"montoPrepago"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={0}
                                                prefix="CLP"
                                                label="Monto prepago"
                                                error={errors.montoPrepago}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"dividendosImpagos"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={0}
                                                label="Dividendos impagos"
                                                error={errors.dividendosImpagos}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputText
                                                name={"monedaOrigen"}
                                                control={control}
                                                desabilitado
                                                readonly
                                                label="Moneda de origen"
                                                error={errors.monedaOrigen}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"montoPrepagoCapital"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={0}
                                                prefix="CLP"
                                                label="Monto prepago capital"
                                                error={errors.montoPrepagoCapital}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"comisionPrepago"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={0}
                                                prefix="CLP"
                                                label="Comisión prepago"
                                                error={errors.comisionPrepago}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"interesDevengado"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={0}
                                                prefix="CLP"
                                                label="Interés devengado"
                                                error={errors.interesDevengado}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"segurosMesPrepago"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={0}
                                                prefix="CLP"
                                                label="Seguros mes prepago"
                                                error={errors.segurosMesPrepago}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"provisionDividendos"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={0}
                                                prefix="CLP"
                                                label="Provisión dividendos"
                                                error={errors.provisionDividendos}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"montoDividendosImpagos"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={0}
                                                prefix="CLP"
                                                label="Monto dividendos impagos"
                                                error={errors.montoDividendosImpagos}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"interesPenalDividendos"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={0}
                                                prefix="CLP"
                                                label="Interés penal dividendos"
                                                error={errors.interesPenalDividendos}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"gastosCobranzaDividendo"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={0}
                                                prefix="CLP"
                                                label="Gastos de cobranza dividendo"
                                                error={errors.gastosCobranzaDividendo}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"gastosAlzamiento"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={0}
                                                prefix="CLP"
                                                label="Gastos de alzamiento"
                                                error={errors.gastosAlzamiento}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"totalAPagar"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={0}
                                                prefix="CLP"
                                                label="Total a pagar"
                                                error={errors.totalAPagar}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputFecha 
                                                name="fechaPago"
                                                control={control}
                                                label={isLiquidar ? "Fecha Pago" : "Fecha Remesa"}
                                                error={errors.fechaPago}
                                                fecha={watcher.fechaPago}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"tipoCambioMonedaOrigen"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={4}
                                                prefix="CLP"
                                                label="Tipo de cambio moneda origen"
                                                error={errors.tipoCambioMonedaOrigen}
                                            />
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, lg: 3 }}>
                                            <InputNumber
                                                name={"nuevoSaldoActual"}
                                                control={control}
                                                disabled
                                                readonly
                                                decimales={4}
                                                label={`Nuevo saldo actual (${(monedaOrigenWatcher ?? "").toUpperCase()})`}
                                                error={errors.nuevoSaldoActual}
                                            />
                                        </Grid2>
                                    </Grid2> 
                                    { isLiquidar && (
                                        <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                                            <Grid2 size={{ xs: 12, lg: 6 }}>
                                                <InputTextArea 
                                                    name={"notaRecomendaciones"}
                                                    control={control}
                                                    label="Nota recomendaciones"
                                                    error={errors.notaRecomendaciones}
                                                />
                                            </Grid2>  
                                            <Grid2 size={{ xs: 12, lg: 6 }}>
                                                <InputTextArea 
                                                    name={"notaValidezPrepago"}
                                                    control={control}
                                                    label="Nota validez prepago"
                                                    error={errors.notaValidezPrepago}
                                                />
                                            </Grid2> 
                                            <Grid2 size={{ xs: 12, lg: 6 }}>
                                                <InputTextArea 
                                                    name={"notaFormaPago"}
                                                    control={control}
                                                    label="Nota forma pago"
                                                    error={errors.notaFormaPago}
                                                />
                                            </Grid2> 
                                        </Grid2>
                                    ) }
                                </>
                            </CustomAccordion>
                            <PermissionGuard permissions={[TipoFuncionalidad.Administrar_prepago]}>
                            <Grid2 container size={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "10px" }} spacing={3}>
                                { isLiquidar
                                    ? <MButton variant="contained" color="primary" startIcon={<Calculate />} onClick={handleRecalcularLiquidacion}>Recalcular</MButton>
                                    : <MButton variant="contained" color="primary" startIcon={<Calculate />} onClick={handleRecalcularRemesaPrepago}>Recalcular</MButton>
                                }
                                
                                { isLiquidar
                                    ? <MButton type="submit" variant="contained" color="primary" startIcon={<AttachMoney />}>Generar Liquidación Prepago</MButton>
                                    : <MButton type="submit" variant="contained" color="primary" startIcon={<AttachMoney />} disabled={!isValidToGenerate}>Generar Remesa Prepago</MButton>
                                }
                                <MButton variant="contained" color="info" startIcon={<ArrowBack />} onClick={cancelarLiquidacion}>
                                    Cancelar
                                </MButton>
                            </Grid2>
                            </PermissionGuard>
                        </form>                       
                    </Suspense>
                </CardContent>
            </Card>
        </>
    )
}

export default LiquidarRemesarSolicitud;